import { Router, RouteComponentProps } from "@reach/router"
import { Policies } from "./Policies"
import { Policy } from "./policy"

export const PoliciesRouter: React.FC<RouteComponentProps> = () => (
  <Router>
    <Policies default />
    <Policy path="/:id" />
  </Router>
)
